var _path, _path2, _path3, _ellipse, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTracking(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6154 3.16364V2C17.6154 1.44772 17.1677 1 16.6154 1H3.84616C3.29388 1 2.84616 1.44772 2.84616 2V8.34546C2.84616 8.89774 3.29388 9.34546 3.84616 9.34546H16.6154C17.1677 9.34546 17.6154 8.89774 17.6154 8.34546V7.18182M17.6154 3.16364V7.18182M17.6154 3.16364H19.1539V7.18182H17.6154M20.0769 7.8V7.8C19.5671 7.8 19.1539 7.38673 19.1539 6.87692V3.46853C19.1539 2.95873 19.5671 2.54545 20.0769 2.54545V2.54545C20.5867 2.54545 21 2.95873 21 3.46853V6.87692C21 7.38673 20.5867 7.8 20.0769 7.8Z",
    stroke: "#2A2D34",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61539 10.8906C9.3077 13.3634 8.07693 15.8361 2.84616 15.8361",
    stroke: "#2A2D34",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.0001V13.0547",
    stroke: "#2A2D34",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.69232,
    cy: 2.54592,
    rx: 0.615385,
    ry: 0.618182,
    fill: "#00A651"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15338 13.2451C7.89469 13.2451 8.50003 13.8494 8.50006 14.5996C8.50006 15.3498 7.89471 15.9541 7.15338 15.9541C6.41226 15.9539 5.80768 15.3497 5.80768 14.5996C5.80771 13.8496 6.41228 13.2454 7.15338 13.2451Z",
    fill: "#2A2D34",
    stroke: "#00A651"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracking);
export default __webpack_public_path__ + "static/media/tracking.bc0f5958a18d89ecc4740e17a4154512.svg";
export { ForwardRef as ReactComponent };